import React from 'react';
import PropTypes from 'prop-types';
import GoogleMapReact from 'google-map-react';
import {
  StaticGoogleMap,
  Marker as StaticMarker
} from 'react-static-google-map';
import Marker from './Marker';
import styles from './styles.less';

const Map = ({
  defaultCenter,
  center,
  defaultZoom,
  zoom,
  markers,
  activeMarker,
  onChange,
  gestureHandling,
  isStaticMap,
  staticMapSizes
}) => {
  const onGoogleApiLoaded = ({ map }) => {
    process.map = map;
  };

  return (
    <>{isStaticMap
      ? <a
        rel="noopener noreferrer"
        target="_blank"
        href={`https://www.google.com/maps/search/?api=1&query=${markers[0]?.lat},${markers[0]?.lng}`}
      >
        <StaticGoogleMap
          size={staticMapSizes}
          scale={2}
          apiKey={process.env.GOOGLE_MAPS_API_KEY}
          zoom={13}
          className={styles.staticGoogleMapImg}
        >
          {markers.map(marker => (
            <StaticMarker
              key={`map-marker-${marker.id || `${marker.lat}-${marker.lng}`}`}
              location={marker}
              iconURL="https://www.course.am/static/images/map-marker.png?3"
              scale={4}
            />
          ))}
        </StaticGoogleMap>
      </a>
      : <GoogleMapReact
        bootstrapURLKeys={{ key: process.env.GOOGLE_MAPS_API_KEY }}
        onGoogleApiLoaded={onGoogleApiLoaded}
        onChange={onChange}
        defaultCenter={defaultCenter}
        defaultZoom={defaultZoom}
        center={center || defaultCenter}
        zoom={zoom || defaultZoom}
        maxZoom={15}
        options={maps => ({
          zoomControlOptions: {
            position: maps.ControlPosition.TOP_RIGHT,
          },
          fullscreenControl: false,
          gestureHandling,
        })}
        yesIWantToUseGoogleMapApiInternals
      >
        {markers.map(marker => (
          <Marker
            active={
              activeMarker && marker.lat === activeMarker.lat && marker.lng === activeMarker.lng
            }
            key={`map-marker-${marker.id || `${marker.lat}-${marker.lng}`}`}
            {...marker}
          />
        ))}
      </GoogleMapReact>
    }
    </>
  );
};

Map.propTypes = {
  defaultCenter: PropTypes.object.isRequired,
  defaultZoom: PropTypes.number.isRequired,
  center: PropTypes.object,
  zoom: PropTypes.number,
  markers: PropTypes.array,
  activeMarker: PropTypes.object,
  onChange: PropTypes.func,
  gestureHandling: PropTypes.string,
  isStaticMap: PropTypes.bool,
  staticMapSizes: PropTypes.string,
};

Map.defaultProps = {
  center: null,
  zoom: null,
  markers: [],
  activeMarker: null,
  onChange: () => null,
  gestureHandling: 'greedy',
  isStaticMap: false,
  staticMapSizes: '600x250',
};

export default Map;
